import api from "services/api";

interface Category {
  chartCount: number;
  icon: string;
  id: number;
  name: string;
  url: string;
}

type CategoryEntity = {
  ids: number[];
  entities: Record<number, Category>;
};

export const INITIAL_CATEGORY_ENTITY: CategoryEntity = {
  ids: [],
  entities: {},
};

const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    foreCategoryEntity: build.query<CategoryEntity, void>({
      query: () => "/categories",
      transformResponse(data: Category[], meta, arg) {
        const entity: CategoryEntity = {
          ids: [],
          entities: {},
        };

        data.forEach((x) => {
          entity.ids.push(x.id);
          entity.entities[x.id] = x;
        });

        return entity;
      },
    }),
    foreCategory: build.query<Category, string>({
      query: (id) => `/categories/${id}`,
    }),
  }),
  overrideExisting: false,
});

export const { useForeCategoryEntityQuery, useForeCategoryQuery } = extendedApi;
